import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { HTMLAttributes, forwardRef } from "react";
import classes from "./text.module.css";

export type TextProps = HTMLAttributes<HTMLElement> & {
  asChild?: boolean;
  maxLines?: number;
};

export const Text = forwardRef<HTMLElement, TextProps>(
  (
    { asChild, className = "", maxLines, style, ...props },
    ref,
  ): React.ReactElement => {
    const Comp: React.ElementType = asChild ? Slot : "p";
    const isSingleLine = maxLines === 1;
    return (
      <Comp
        ref={ref as React.LegacyRef<HTMLParagraphElement>}
        className={clsx(
          className,
          isSingleLine
            ? classes.truncateSingleLine
            : maxLines
              ? classes.truncate
              : undefined,
        )}
        style={{ "--truncate": maxLines, ...style } as React.CSSProperties}
        {...props}
      />
    );
  },
);

Text.displayName = "Text";
